import { useSnapshot } from 'valtio';

import { workspaceConfigState } from 'state/workspace-config';

export const useWorkspaceConfig = () => {
    const { config } = useSnapshot(workspaceConfigState);
    return config;
};
